module.exports = "<div class=\"ubg-banner mat-body-2\" [ngClass]=\"getClasses()\">\n  <ng-content></ng-content>\n  <div class=\"clearfix\"></div>\n</div>"